import React, { useEffect, useState } from "react";
import "./NonPerformingLoansReport.scss";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const NonPerformingLoansReport = ({startDate, endDate, duration, isCustomFilter}) => {
    const [reportData, setReportData] = useState([]);

    useEffect(()=> {
      getReportData();
    },[duration, isCustomFilter]);

    const columns = [
      {
        label: 'Loan ID',
        getValue: (row) => row.li?.LoanID ?? ''
      },
      {
        label: 'Borrower Name',
        getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
      },
      {
        label: 'Loan Amount',
        getValue: (row) => row.li?.LoanAmount ?? '',
        align: 'right',
        amount: true
      },
      {
        label: 'Outstanding Balance',
        getValue: (row) => row.record?.AmountDue ?? '',
        align: 'right',
        amount: true
      },
      {
        label: 'Days Past Due',
        getValue: (row) => row.record?.DaysPastDue ?? ''
      }
    ];
  
    const getReportData = async() => {
      try {
        const response = await commonRunQuery(253, `${startDate}/${endDate}`);
        if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
          const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
          setReportData(reportsArray);
          console.log("NonPerformingLoansReport_getReportData==========",reportsArray);
        } else {
          setReportData([]);
        }
        console.log("getReportData---------------",response);
      } catch (error) {
        console.log("getReportData_error==========",error);
      }
    }

    return (
      <Box>
        <LoanReportsTable 
          data={reportData} 
          columns={columns} 
          title="Non Performing Loans Report" 
          formatRow={(row) => [
            row.li?.LoanID,
            row.record?.BorrowerName,
            row.li?.LoanAmount,
            row.record?.AmountDue,
            row.record?.DaysPastDue
          ]} 
        />
      </Box>
    )
}

export default NonPerformingLoansReport;
